import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

 @NgModule({
  imports: [
    LoadingBarHttpClientModule,
    LoadingBarRouterModule
  ],
  exports: [
    LoadingBarHttpClientModule,
    LoadingBarRouterModule
  ],
  declarations: []
})
export class LoaderModule { }
